'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NON_DEFAULT_BUILD_SUFFIX = exports.NON_DEFAULT_BUILD_SUFFIX = 'appspot.com';

var NON_DEFAULT_URL_ENVIRONMENT_PREFIX = exports.NON_DEFAULT_URL_ENVIRONMENT_PREFIX = '.';

var BASE_TEST_URL = exports.BASE_TEST_URL = 'test-freightos.com';

var TEST1_ENV = exports.TEST1_ENV = {
  urlInfix: 'tradeos-test1',
  environmentDomain: BASE_TEST_URL
};

var STAGING_ENV = exports.STAGING_ENV = {
  urlInfix: 'freightos-staging',
  environmentDomain: 'staging-freightos.com'
};

var PRODUCTION_ENV = exports.PRODUCTION_ENV = {
  urlInfix: 'tradeos1',
  environmentDomain: 'freightos.com'
};

var NON_DEFAULT_INFIX_ENVIRONMENT_MAP = exports.NON_DEFAULT_INFIX_ENVIRONMENT_MAP = [TEST1_ENV, STAGING_ENV, PRODUCTION_ENV];

var SELLER_PROFILES_LOGOS_BUCKET = exports.SELLER_PROFILES_LOGOS_BUCKET = '/sellers/logos/';

var YUSEN_ICONS = exports.YUSEN_ICONS = '/yusen/icons/';

var SSO_PATH = exports.SSO_PATH = '/sso/login';

var LOCAL_ENV_SUFFIX = exports.LOCAL_ENV_SUFFIX = '.local';

var MONITORING_ENDPOINT_PATH = exports.MONITORING_ENDPOINT_PATH = '/api/v1/monitor';

var MICROSERVICES_DOMAINS = exports.MICROSERVICES_DOMAINS = {
  LH_GATEWAY: {
    NAME: 'lh-gateway',
    DEFAULT_LOCAL_PORT: 8080,
    DEFAULT_URL_PREFIX: 'lighthouse',
    DEFAULT_API_PATH: '',
    DEFAULT_API_VERSION: '',
    DEFAULT_MS_DOMAIN: ''
  },
  GEOCODER: {
    NAME: 'geocoder',
    DEFAULT_LOCAL_PORT: 5000,
    DEFAULT_URL_PREFIX: 'flux',
    DEFAULT_API_PATH: 'api',
    DEFAULT_API_VERSION: 'v1',
    DEFAULT_MS_DOMAIN: 'geocoder'
  },
  LOCATIONS_SERVICE: {
    NAME: 'locations-service',
    DEFAULT_LOCAL_PORT: 8080,
    DEFAULT_URL_PREFIX: 'flux',
    DEFAULT_API_PATH: 'api',
    DEFAULT_API_VERSION: 'v1',
    DEFAULT_MS_DOMAIN: 'locations'
  },
  AUTH_SERVICE: {
    NAME: 'auth-service',
    DEFAULT_LOCAL_PORT: 9000,
    DEFAULT_URL_PREFIX: 'flux',
    DEFAULT_API_PATH: 'api',
    DEFAULT_API_VERSION: 'v1',
    DEFAULT_MS_DOMAIN: 'auth'
  },
  SELLER_PROFILES: {
    NAME: 'seller-profiles',
    DEFAULT_LOCAL_PORT: 9004,
    DEFAULT_URL_PREFIX: 'flux',
    DEFAULT_API_PATH: 'api',
    DEFAULT_API_VERSION: 'v1',
    DEFAULT_MS_DOMAIN: 'seller-profiles'
  },
  ADDRESS_BOOK: {
    NAME: 'address-book',
    DEFAULT_LOCAL_PORT: 8080,
    DEFAULT_URL_PREFIX: 'flux',
    DEFAULT_API_PATH: 'api',
    DEFAULT_API_VERSION: 'v1',
    DEFAULT_MS_DOMAIN: 'address_book'
  },
  USER_PROFILES: {
    NAME: 'user-profiles',
    DEFAULT_LOCAL_PORT: 8080,
    DEFAULT_URL_PREFIX: 'flux',
    DEFAULT_API_PATH: 'api',
    DEFAULT_API_VERSION: 'v1',
    DEFAULT_URL_PARAMS: 'user-profiles',
    DEFAULT_MS_DOMAIN: 'user-profiles'
  },
  USER_REVIEWS: {
    NAME: 'user-reviews',
    DEFAULT_LOCAL_PORT: 8080,
    DEFAULT_URL_PREFIX: 'flux',
    DEFAULT_API_PATH: 'api',
    DEFAULT_API_VERSION: 'v1',
    DEFAULT_MS_DOMAIN: 'reviews'
  },
  RATES_SERVICE: {
    NAME: 'rates-service',
    DEFAULT_LOCAL_PORT: 8080,
    DEFAULT_URL_PREFIX: 'flux',
    DEFAULT_API_PATH: 'api',
    DEFAULT_API_VERSION: 'v1',
    DEFAULT_URL_PARAMS: 'rates-service',
    DEFAULT_MS_DOMAIN: 'rates-service'
  },
  EMAIL_NOTIFICATION: {
    NAME: 'email_notification',
    DEFAULT_LOCAL_PORT: 8080,
    DEFAULT_URL_PREFIX: 'business-configuration',
    DEFAULT_API_PATH: '',
    DEFAULT_API_VERSION: '',
    DEFAULT_URL_PARAMS: '',
    DEFAULT_MS_DOMAIN: ''
  },
  SELLERS_API: {
    NAME: 'business-api-config',
    DEFAULT_LOCAL_PORT: 8183,
    DEFAULT_URL_PREFIX: 'business-configuration',
    DEFAULT_API_PATH: 'business-api-config',
    DEFAULT_API_VERSION: '',
    DEFAULT_URL_PARAMS: '',
    DEFAULT_MS_DOMAIN: ''
  },
  ADDRESS_BOOK_API: {
    NAME: 'address-book-api',
    DEFAULT_LOCAL_PORT: 8080,
    DEFAULT_URL_PREFIX: 'business-configuration',
    DEFAULT_API_PATH: 'address',
    DEFAULT_API_VERSION: '',
    DEFAULT_URL_PARAMS: '',
    DEFAULT_MS_DOMAIN: ''
  },
  COMMODITIES_API: {
    NAME: 'commodities-api',
    DEFAULT_LOCAL_PORT: 8080,
    DEFAULT_URL_PREFIX: 'business-configuration',
    DEFAULT_API_PATH: 'commodity',
    DEFAULT_API_VERSION: '',
    DEFAULT_URL_PARAMS: '',
    DEFAULT_MS_DOMAIN: ''
  },
  JARVIS: {
    NAME: 'jarvis',
    DEFAULT_LOCAL_PORT: 8086,
    DEFAULT_URL_PREFIX: 'marvel',
    DEFAULT_API_PATH: 'jarvis',
    DEFAULT_API_VERSION: '',
    DEFAULT_MS_DOMAIN: ''
  },
  SESAME: {
    NAME: 'sesame',
    DEFAULT_LOCAL_PORT: 8080,
    DEFAULT_URL_PREFIX: 'marvel',
    DEFAULT_API_PATH: 'sesame',
    DEFAULT_API_VERSION: '',
    DEFAULT_MS_DOMAIN: ''
  },
  QUICKSILVER: {
    NAME: 'quicksilver',
    DEFAULT_LOCAL_PORT: 80,
    DEFAULT_URL_PREFIX: 'marvel',
    DEFAULT_API_PATH: '',
    DEFAULT_API_VERSION: '',
    DEFAULT_MS_DOMAIN: 'quicksilver'
  },
  CONFIGURATION: {
    NAME: 'site-configuration',
    DEFAULT_LOCAL_PORT: 8080,
    DEFAULT_URL_PREFIX: 'site-configuration',
    DEFAULT_API_PATH: 'api',
    DEFAULT_API_VERSION: 'v1',
    DEFAULT_URL_PARAMS: '',
    DEFAULT_MS_DOMAIN: ''
  }
};